const Immutable = require('immutable')
const {
  keyedReviver
} = require('client-v2/common/state/revivers')

class SMSModalRecord extends Immutable.Record({
  // Flags
  isSubmitFailed: Boolean(),
  isSubmitSuccessful: Boolean(),
  isVisible: Boolean()
}) {
  // No methods
}

SMSModalRecord.reviver = keyedReviver(SMSModalRecord, {
})

module.exports = SMSModalRecord
